export enum SchoolTypeEnum{
    Public = "Public",
    Private = "Private"
}